import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IPaletteProps } from 'components/uiKit/ColorPicker'
import { Palette } from 'components/uiKit/ColorPicker'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldPalette: React.FC<IControlProps<IPaletteProps>> = ({
  name,
  onChange,
  value,
  defaultValue,
  ...rest
}) => {
  const handleOnChange = (value: string) => onChange({ name, value })

  return <Palette {...rest} name={name} onChange={handleOnChange} value={value ?? defaultValue} />
}

export default FieldPalette
